module.exports = "/_next/static/images/video_id_7177092177082715438-34a575fc4adf212659c4f5f2b8229534.jpg";